/**
 * Feature List Component - Reusable list with icons
 * Supports different icon types and styling
 */

import React from 'react';

const FeatureList = ({ 
  items = [], 
  iconType = 'check', // 'check', 'star', 'dot'
  iconColor = 'var(--primary-green)',
  textColor = 'var(--secondary-gray)',
  className = '',
  style = {},
  spacing = '0.5rem'
}) => {
  const getIcon = () => {
    switch (iconType) {
      case 'star':
        return '★';
      case 'dot':
        return '•';
      default: // check
        return '✓';
    }
  };

  const listStyles = {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    ...style
  };

  const itemStyles = {
    color: textColor,
    marginBottom: spacing,
    paddingLeft: '1.25rem',
    position: 'relative',
    lineHeight: '1.6',
    textAlign: 'left'
  };

  const iconStyles = {
    position: 'absolute',
    left: '0',
    top: '0',
    color: iconColor,
    fontWeight: 'bold',
    marginRight: '0.35rem'
  };

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <ul className={`feature-list ${className}`} style={listStyles}>
      {items.map((item, index) => (
        <li key={index} style={itemStyles}>
          <span style={iconStyles}>
            {getIcon()}
          </span>
          {item}
        </li>
      ))}
    </ul>
  );
};

export default FeatureList;
